(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-hero"] && !Shopify.designMode) return;
  try {
    
class BundleHeroSwiper extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.bh-swiper-track');
    this.slides = Array.from(this.querySelectorAll('.bh-slide'));
    this.dots = Array.from(this.querySelectorAll('.bh-dot'));
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
    this.track.addEventListener('scroll', () => this.updateActive(), { passive: true });
    this.updateActive();
  }
  updateActive() {
    const trackRect = this.track.getBoundingClientRect();
    const center = trackRect.left + trackRect.width / 2;
    let closest = 0;
    let minDist = Infinity;
    this.slides.forEach((slide, i) => {
      const rect = slide.getBoundingClientRect();
      const dist = Math.abs((rect.left + rect.width / 2) - center);
      if (dist < minDist) { minDist = dist; closest = i; }
    });
    this.dots.forEach((dot, i) => dot.classList.toggle('active', i === closest));
  }
}
if (!customElements.get('bundle-hero-swiper')) customElements.define('bundle-hero-swiper', BundleHeroSwiper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-pricing"] && !Shopify.designMode) return;
  try {
    
class BundleCountdown extends HTMLElement {
  connectedCallback() {
    const minutes = parseFloat(this.dataset.minutes) || 15;
    const storageKey = 'bundle_countdown_' + (this.dataset.id || 'default');
    const now = Date.now();
    let endTime = parseInt(localStorage.getItem(storageKey), 10);
    if (!endTime || isNaN(endTime) || endTime <= now) {
      endTime = now + minutes * 60000;
      localStorage.setItem(storageKey, String(endTime));
    }
    this.endTime = endTime;
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
  tick() {
    const diff = this.endTime - Date.now();
    if (diff <= 0) {
      clearInterval(this.timer);
      if (this.hoursEl) this.hoursEl.textContent = '00';
      if (this.minutesEl) this.minutesEl.textContent = '00';
      if (this.secondsEl) this.secondsEl.textContent = '00';
      return;
    }
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    if (this.hoursEl) this.hoursEl.textContent = String(h).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(m).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(s).padStart(2, '0');
  }
}
if (!customElements.get('bundle-countdown')) customElements.define('bundle-countdown', BundleCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-reviews-slider"] && !Shopify.designMode) return;
  try {
    
class BundleReviews extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.brev-slide'));
    this.dots = Array.from(this.querySelectorAll('.brev-dot'));
    this.current = 0;
    this.perPage = this.getPerPage();
    this.prevBtn = this.querySelector('.brev-btn--prev');
    this.nextBtn = this.querySelector('.brev-btn--next');
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
    this.dots.forEach((d, i) => d.addEventListener('click', () => this.goTo(i)));
    this.startX = null;
    this.addEventListener('touchstart', (e) => { this.startX = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', (e) => {
      if (this.startX === null) return;
      const diff = e.changedTouches[0].clientX - this.startX;
      if (Math.abs(diff) > 40) { if (diff < 0) this.next(); else this.prev(); }
      this.startX = null;
    });
    const ro = new ResizeObserver(() => {
      const pp = this.getPerPage();
      if (pp !== this.perPage) { this.perPage = pp; this.show(this.current); }
    });
    ro.observe(this);
    this.show(0);
  }
  getPerPage() {
    const w = this.offsetWidth;
    if (w < 600) return 1;
    if (w < 900) return 2;
    return 3;
  }
  show(idx) {
    const total = this.slides.length;
    const maxStart = Math.max(0, total - this.perPage);
    this.current = Math.min(Math.max(idx, 0), maxStart);
    this.slides.forEach((s, i) => s.classList.toggle('visible', i >= this.current && i < this.current + this.perPage));
    this.dots.forEach((d, i) => d.classList.toggle('active', i === this.current));
  }
  next() { this.show(this.current + 1); }
  prev() { this.show(this.current - 1); }
  goTo(i) { this.show(i); }
}
if (!customElements.get('bundle-reviews')) customElements.define('bundle-reviews', BundleReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
